/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Watch_Page_TitleInputs */

const de_watch_page_title = /** @type {(inputs: Watch_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetzt Fernsehen`)
};

/** @type {(inputs: Watch_Page_TitleInputs) => LocalizedString} */
const en_watch_page_title = de_watch_page_title;

/**

* @param {Watch_Page_TitleInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const watch_page_title = /** @type {((inputs?: Watch_Page_TitleInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Watch_Page_TitleInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_watch_page_title(inputs)
	return en_watch_page_title(inputs)
});